/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamPracticeEnsureResponse } from './oralExamPracticeEnsureResponse';

export type GenericApiResponseOralExamPracticeEnsureResponseData = OralExamPracticeEnsureResponse | null;
